import React, { ReactNode, useReducer } from 'react'

interface ColumnItem {
  key: React.Key
  dataIndex: string
  title: string
  width?: string | number
  render?: (text: any, record: any, index: number) => ReactNode
}
interface scrollOption {
  scrollToFirstRowOnChange?: boolean
  x?: string | number | true | undefined
  y?: string | number | undefined
}
export interface Props {
  className?: string
  bordered?: boolean
  columns?: ColumnItem[]
  dataSource?: any[]
  isLoading?: boolean
  pagination?: any
  rowKey?: string | ((record: any) => string)
  // 设置scroll之后会影响表格自适应
  scroll?: scrollOption
  size?: 'small' | 'middle' | 'large'
  onCheckChange?: (selectedRowKeys: React.Key[], selectedRows: any[]) => void
}
interface State {
  selectedRowKeys: React.Key[]
}
const initialState = {
  selectedRowKeys: [],
}
type ActionType = 'setSelectedRowKeys'
interface Action {
  type: ActionType
  payload: any
}
const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setSelectedRowKeys':
      newstate.selectedRowKeys = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}
/**
 * 设置当前选中行
 * @param val
 * @returns
 */
const setSelectedRowKeys = (val: any): Action => ({
  type: 'setSelectedRowKeys',
  payload: val,
})
export default function useHook(props: Props) {
  const {
    columns = [],
    dataSource = [],
    isLoading = false,
    onCheckChange,
  } = props
  const [state, dispatch] = useReducer(reducer, initialState)
  const { selectedRowKeys } = state

  const handleSelectChange = (selectedRowKeys: any, selectedRows: any[]) => {
    onCheckChange?.(selectedRowKeys, selectedRows)
    dispatch(setSelectedRowKeys(selectedRowKeys))
  }
  return { columns, dataSource, isLoading, selectedRowKeys, handleSelectChange }
}
import React, { ReactNode, useReducer } from 'react'

interface ColumnItem {
  key: React.Key
  dataIndex: string
  title: string
  width?: string | number
  render?: (text: any, record: any, index: number) => ReactNode
}
interface scrollOption {
  scrollToFirstRowOnChange?: boolean
  x?: string | number | true | undefined
  y?: string | number | undefined
}
export interface Props {
  className?: string
  bordered?: boolean
  columns?: ColumnItem[]
  dataSource?: any[]
  isLoading?: boolean
  pagination?: any
  rowKey?: string | ((record: any) => string)
  // 设置scroll之后会影响表格自适应
  scroll?: scrollOption
  size?: 'small' | 'middle' | 'large'
  onCheckChange?: (selectedRowKeys: React.Key[], selectedRows: any[]) => void
}
interface State {
  selectedRowKeys: React.Key[]
}
const initialState = {
  selectedRowKeys: [],
}
type ActionType = 'setSelectedRowKeys'
interface Action {
  type: ActionType
  payload: any
}
const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setSelectedRowKeys':
      newstate.selectedRowKeys = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}
/**
 * 设置当前选中行
 * @param val
 * @returns
 */
const setSelectedRowKeys = (val: any): Action => ({
  type: 'setSelectedRowKeys',
  payload: val,
})
export default function useHook(props: Props) {
  const {
    columns = [],
    dataSource = [],
    isLoading = false,
    onCheckChange,
  } = props
  const [state, dispatch] = useReducer(reducer, initialState)
  const { selectedRowKeys } = state

  const handleSelectChange = (selectedRowKeys: any, selectedRows: any[]) => {
    onCheckChange?.(selectedRowKeys, selectedRows)
    dispatch(setSelectedRowKeys(selectedRowKeys))
  }
  return { columns, dataSource, isLoading, selectedRowKeys, handleSelectChange }
}
